<template>
  <div>
    <SPSection v-if="section" :section="section"/>
    <SPSection v-else v-for="section in menu.sections" :key="section.id" :section="section"/>
    <p v-if="showFootnotes && menu.footnote">{{menu.footnote}}</p>
  </div>
</template>

<script>
import SPSection from "./SPSection.vue";

export default {
  props: ["menu", "section", "showFootnotes"],
  components: {
    SPSection
  }
};
</script>
